import React from "react";
import { MapPin, Bell, Building2, Mail, ExternalLink } from "lucide-react";
import { eventInfo } from "../mock";
import Reveal from "../components/Reveal";
import HubSpotFormEmbed from "../components/HubSpotFormEmbed";

const Registration = () => {
  return (
    <main>
      <section className="eco-grad-hero pt-[88px] sm:pt-[100px] pb-12 text-white relative overflow-hidden">
        <div className="absolute -top-40 -right-32 w-[520px] h-[520px] rounded-full bg-[#ff243d]/15 blur-[140px] aurora-pulse" />
        <div className="absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-[#143DE5]/15 blur-[140px] aurora-pulse" style={{ animationDelay: "2s" }} />
        <div className="max-w-[1320px] mx-auto px-5 sm:px-6 lg:px-10 relative">
          <Reveal>
            <div className="inline-flex items-center gap-2 text-sm tracking-[0.2em] uppercase text-white/60 mb-3">
              <Bell className="w-4 h-4 text-[#ff243d]" /> Stay tuned
            </div>
            <h1 className="font-display text-[2.25rem] sm:text-5xl md:text-6xl font-semibold leading-tight max-w-3xl">
              Get notified when registration opens
            </h1>
            <div className="mt-8 flex flex-wrap gap-6 text-white/80 text-sm">
              <a href={eventInfo.mapUrl} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white">
                <MapPin className="w-4 h-4 text-[#ff243d]" />
                <span className="link-underline">{eventInfo.venue}, {eventInfo.city}</span>
                <ExternalLink className="w-3 h-3 opacity-70" />
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-black text-white py-14 md:py-20">
        <div className="max-w-[1320px] mx-auto px-5 sm:px-6 lg:px-10 flex flex-col lg:flex-row lg:items-start gap-10 lg:gap-24">
          <div className="w-full lg:w-[75%] lg:shrink-0 min-w-0">
            <HubSpotFormEmbed
              src="/hubspot-attendee-form.html"
              title="Register Interest form"
            />
          </div>

          <aside className="w-full lg:flex-1 lg:flex lg:justify-end">
            <div className="w-full lg:max-w-[260px]">
              <div className="rounded-2xl border border-white/10 p-8 hover:border-[#ff243d] transition-colors group">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center"><Building2 className="w-5 h-5 text-[#ff243d]" /></div>
                  <div className="min-w-0">
                    <div className="text-[10px] tracking-[0.25em] uppercase text-white/50">Venue</div>
                    <div className="font-semibold text-white truncate">{eventInfo.venue}</div>
                  </div>
                </div>
                <p className="text-sm text-white/70 mt-3">{eventInfo.venueAddress}</p>
                <a href={eventInfo.mapUrl} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-[#ff243d] hover:gap-2.5 transition-all">
                  Open in Google Maps <ExternalLink className="w-3.5 h-3.5" />
                </a>
              </div>

              <div className="mt-6 rounded-2xl border border-white/10 p-8">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center"><Mail className="w-5 h-5 text-[#ff243d]" /></div>
                  <div>
                    <div className="text-[10px] tracking-[0.25em] uppercase text-white/50">Questions</div>
                    <a href="mailto:info@ecosystm.io" className="font-semibold text-white hover:text-[#ff243d]">info@ecosystm.io</a>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
};

export default Registration;
